import config from '@config';
import merge from 'lodash/merge';

const fontFamily = 'FedraSansStd-medium';

const commonLangStyle = ({ lang, ...props }) => {
  const isIndian = config.indianLang.indexOf(lang) > -1;
  const styleObj = {
    title: {
      fontSize: { base: '40px', md: '48px' },
      textAlign: { base: 'center' },

      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      lineHeight: { base: '44px', md: '52.8px' },
    },
    titleSubtext: {
      fontWeight: '500',
      fontStyle: 'italic',
      color: '#EC1C2D',
    },
    text3: {
      fontWeight: '400',
      fontStyle: 'normal',
      color: '#FFFF',
    },
    category: {
      fontWeight: '500',
      // fontStyle: 'normal',
      color: '#FFFFFF99',
      fontSize: { base: '12px' },
      // textAlign: { base: 'right' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      lineHeight: { base: '15.6px' },
    },
    TabsText: {
      fontWeight: '500',
      // fontStyle: 'normal',
      // color: '#FFFFFF',
      fontSize: { base: '18px' },
      textAlign: { base: 'center' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      lineHeight: { base: '19.8px' },
    },

    SubHeading: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '22px', md: '2rem' },
      lineHeight: { base: '28.6px', md: '41.6px' },
      fontWeight: '500',
      textAlign: { base: 'center' },
      color: '#fff',
    },
    item: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '20px' },
      lineHeight: { base: '28px' },
      color: '#FFFFFFB2',
      textAlign: { base: 'left', md: 'left' },
    },
    desc: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '1rem', md: '24px' },
      fontWeight: '400',
      lineHeight: { base: '20px', md: '28.8px' },
      color: '#FFFFFFB2',
    },
    closedMessage: {
      fontSize: { lg: '80px', md: '60px', base: '42px' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
    },
    bottomText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { md: '18px', base: '20px' },
      lineHeight: { base: '20px', md: '22px' },
      color: '#fff',
    },

    item1: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      fontSize: { base: '40px', md: '32px' },
      fontWeight: '400',
      fontStyle: 'italic',
      lineHeight: { base: '48px', md: '38.4px' },
      color: '#FFFFFF',
    },
    item2: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      fontSize: { base: '64px', md: '72px' },
      fontWeight: '500',
      textAlign: { base: 'left' },
      fontStyle: 'italic',
      lineHeight: { base: '57.6px', md: '64.8px' },
      color: ' #EC1C2D',
    },
    item3: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      fontSize: { base: '40px', md: '48px' },
      fontWeight: '400',
      textAlign: { base: 'left' },
      lineHeight: { base: '40px', md: '48px' },
      color: ' #FFF',
    },
  };

  const finalObj = merge(styleObj, { ...props });
  return finalObj;
};

const InsightSt = {
  en: commonLangStyle(
    { lang: 'en' },
    {
      heading: {
        fontFamily: 'FedraSansStd-book',
        fontSize: 60,
        lineHeight: '60px',
      },
    }
  ),
  bn: commonLangStyle(
    { lang: 'bn' },
    {
      title: {
        fontFamily: 'Anek-bangla',
      },
    }
  ),
  hi: commonLangStyle({
    lang: 'hi',
  }),
  te: commonLangStyle({ lang: 'te' }),
  kn: commonLangStyle({ lang: 'kn' }),
  gu: commonLangStyle({ lang: 'gu' }),
  mr: commonLangStyle({ lang: 'mr' }),
  ml: commonLangStyle({ lang: 'ml' }),
  'zh-tw': commonLangStyle({ lang: 'zh-tw' }),
  zh: commonLangStyle({ lang: 'zh' }),
  it: commonLangStyle({ lang: 'it' }),
  fr: commonLangStyle({ lang: 'fr' }),
  de: commonLangStyle({ lang: 'de' }),
  es: commonLangStyle({ lang: 'es' }),
  ru: commonLangStyle({ lang: 'ru' }),
  ta: commonLangStyle({ lang: 'ta' }),
  cn: commonLangStyle({ lang: 'cn' }),
  ar: commonLangStyle({
    lang: 'ar',
  }),
  id: commonLangStyle({ lang: 'id' }),
};
export default InsightSt;
